<template>
  <div class="animated fadeIn list-agen-koran">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Buka</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales(AE) | Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.collector_name" placeholder="Kolektor" class="ml-2"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCollectShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kiriman_name" @change="tblData.kiriman_code=''" placeholder="Jenis Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-button class="btn btn-success ml-3 mr-1" @click="search()">
              <i class="fa fa-refresh"></i> Terapkan Filter
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i> Hapus Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th >                  
              <span class="sr-only">action</span>
            </b-th>
            <b-th colspan="2">AGEN/PELANGGAN</b-th>
            <b-th colspan="5">
              <span class="sr-only">alamat, phone, kota, jenis, ae</span>
            </b-th>
            <b-th variant="primary" colspan="7" class="text-center">POLA KIRIMAN</b-th>
          </b-tr>
        </template>

      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(DeliveryAddr)="data">
          <span v-if="(data.item.DeliveryAddr)">{{data.item.DeliveryAddr}}</span>
          <span v-else>
            {{data.item.Address1}}
            {{data.item.Address2}}
          </span>
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>

        <!-- <template v-slot:cell(kota_name)="data">
          {{data.item.kota_name}}
          <span
            v-if="((data.item.area_name) && (data.item.area_name!=data.item.kota_name))"
          >| {{data.item.area_name}}</span>&nbsp;
        </template> -->
      </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right" v-if="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Hapus pesanan ?" :centered="true" @ok="deleteData">
      <p class="mb-1"><b>{{terpilih.CustName}}</b> akan dihapus dari pesanan.</p>
      <p class="font-weight-bold m-0 text-danger">Peringatan: Anda tidak dapat membatalkan tindakan ini.</p>
    </b-modal>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
    </b-modal>
    <b-modal
      v-model="lkuKoranCollectShow"
      size="lg"
      :hide-footer="true"
      title="List Kolektor"
      :centered="true"
    >
      <lku-collector @click="onSelectKoranCollect"></lku-collector>
    </b-modal>
    <b-modal
      v-model="lkuKoranKirimanCodeShow"
      size="lg"
      :hide-footer="true"
      title="Jenis Kiriman"
      :centered="true"
    >
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman"></lku-koranjeniskiriman>
    </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
  .list-agen-koran {
      table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
}
</style>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";

import pesanan_pascabayar from "../../apis/koran_pesanan_pascabayar";
import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: {
    Loading,
    lkuCustomerkoran,
    lkuSalesae,
    lkuCollector,
    lkuKoranjeniskiriman
  },
  data() {
    return {
      showDelConfirm: false,
      pagination: false,
      showFilter: false,
      isLoading: true,
      showReport: false,
      reportUrl: null,
      terpilih: { pascabayarkey: "" },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        koran: "1"
      },
      tgl1: null,
      tgl2: null,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranCollectShow: false,
      lkuKoranKirimanCodeShow: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "CustCode",
          label: "Kode",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Agen",
          sortable: true
        },
        {
          key: "DeliveryAddr",
          label: "Alamat Pengiriman"
        },
        {
          key: "PhoneNo",
          label: "Phone/Fax",
        },
        {
          key: "kota_name",
          label: "Kota/wil",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales",
          sortable: true
        },
        {
          key: "seninEcer",
          label: "sen",
          variant: "primary",
          thStyle: "width:40px",
        },
        {
          key: "selasaEcer",
          label: "sel",
          thStyle: "width:40px",
        },
        {
          key: "rabuEcer",
          label: "rab",
          thStyle: "width:40px",
        },
        {
          key: "kamisEcer",
          label: "kam",
          thStyle: "width:40px",
        },
        {
          key: "jumatEcer",
          label: "jum",
          thStyle: "width:40px",
        },
        {
          key: "sabtuEcer",
          label: "sab",
          thStyle: "width:40px",
        },
        {
          key: "mingguEcer",
          label: "ming",
          thStyle: "width:40px",
          variant: "primary",
        },
      ];
      return fields;
    }
  },
  watch: {
    tgl1(val) {
      if (val !== null) this.tblData.tgl1 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl1 = null;
    },
    tgl2(val) {
      if (val !== null) this.tblData.tgl2 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl2 = null;
    }
  },
  created: async function() {},
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuKoranSalesShow = false;
    },
    onSelectKoranCollect: function(_selected) {
      this.tblData.collector_id = _selected.collector_id;
      this.tblData.collector_name = _selected.collector_name;
      this.lkuKoranCollectShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.agenkoran) {
            this.tblData[key] = filter.agenkoran[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.agenkoran.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.agenkoran;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await pesanan_pascabayar.list(this.tblData);      
                  // list.forEach(function(el, idx) {
                  //   list[idx].periode_pesanan = `${moment(el.tglbuka).format(
                  //     "DD-MMM-YYYY"
                  //   )}${
                  //     el.tgltutup !== null
                  //       ? " - " + moment(el.tgltutup).format("DD-MMM-YYYY")
                  //       : ""
                  //   } `;
                  // });
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await pesanan_pascabayar.list(this.tblData);   
                  // list.forEach(function(el, idx) {
                  //   list[idx].periode_pesanan = `${moment(el.tglbuka).format(
                  //     "DD-MMM-YYYY"
                  //   )}${
                  //     el.tgltutup !== null
                  //       ? " - " + moment(el.tgltutup).format("DD-MMM-YYYY")
                  //       : ""
                  //   } `;
                  // });

                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }

    },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    clearFilter() {
      this.tblData.CustName = "";
      this.tblData.customer_id = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.kiriman_code = '';
      this.tblData.kiriman_name = '';
      this.tblData.salesae_id = "";
      this.tblData.salesae_name = "";
      this.tblData.collector_codename = "";
      this.tblData.collector_id = "";
      this.tblData.collector_name = "";
      this.refresh();
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','tgl1','tgl2','CustName','CustCode', 'customer_id','kiriman_code','kiriman_name','salesae_name','salesae_id','collector_name','collector_id','bill2group'];
      let filtered = false;
      const agenkoran={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              agenkoran[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          agenkoran.page=this.tblData.page;
          agenkoran.limit=this.tblData.limit;
          agenkoran.sortBy=this.tblData.sortBy;
          agenkoran.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.agenkoran=agenkoran;
          this.$store.commit("filter", filter);
      }
    },      
    rowEdit(record) {
      this.terpilih = record;
      this.edit();
    },
    // rowPrint(record) {
    //   this.rowClicked(record);
    //     this.print();        
    // },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },      

    add: function() {
      this.saveFilter();
      router.push({ name: "koran.pesananpermanenfrm" });
    },
    edit: function() {
      if (this.terpilih.pascabayarkey) {
      this.saveFilter();
        router.push({
          name: "koran.pesananpermanenfrm",
          params: { pascabayarkey: this.terpilih.pascabayarkey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.pascabayarkey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await pesanan_pascabayar.remove(this.terpilih);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      // if (this.terpilih.pascabayarkey == record.pascabayarkey) {
      //   this.edit();
      // } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      // }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await pesanan_pascabayar.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("/koran/home");
    }
  }
};
</script>